// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.completion.LeaseCompletionWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseCompletionWebApiHandler_getCompletionStatus,
  LeaseCompletionWebApiHandler_getCompletionStatus_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetCompletionStatusResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetCompletionStatusParams {
  leaseId: number;
}

export type LeaseCompletionWebApiHandler_getCompletionStatus_Options = UseQueryOptions<
  GetCompletionStatusResponseDto,
  unknown,
  GetCompletionStatusResponseDto,
  Array<string | GetCompletionStatusParams>
>;

const LeaseCompletionWebApiHandler_getCompletionStatus_GetKey = (getParams: GetCompletionStatusParams) => [
  LeaseCompletionWebApiHandler_getCompletionStatus_Path,
  getParams,
];

/**
 * get the completion status for lease
 */
export const useLeaseCompletionWebApiHandler_getCompletionStatus = (
  getParams: GetCompletionStatusParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseCompletionWebApiHandler_getCompletionStatus_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseCompletionWebApiHandler_getCompletionStatus_GetKey(getParams),
    queryFn: () => LeaseCompletionWebApiHandler_getCompletionStatus(getParams, httpClient),
  });
};
useLeaseCompletionWebApiHandler_getCompletionStatus.getKey = LeaseCompletionWebApiHandler_getCompletionStatus_GetKey;
